var validationPopupsMixin = {

	methods: {
		showErrorsList(errors) {
			this.$swal({
				title: "Please fix the following errors:",
				html: this.errorsHtmlArray(errors).join(''),
				icon: "error",
				buttonsStyling: false,
				confirmButtonText: this.translate("Ok"),
				showCancelButton: false,
				customClass: {
					confirmButton: "btn btn-danger"
				},
				width: '50rem'
			});
		},

		errorsHtmlArray(errors) {
			let errorsArray = [];
			$.each(errors, function( index, errorLine ) {
				let htmlLine = '<div class="d-flex justify-content-between my-2 dm-stats-modal-list"><div class="col">' + errorLine[0] + '</div></div>'; // NB: Each error line text comes as an array, not a string.
				errorsArray.push(htmlLine);
			});

			return errorsArray;
		},
	},

};

export { validationPopupsMixin };
